import React, { useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import Button from "../../../common/button/button";
import useTranslatedValue from "../../../../hooks/useTranslatedValue";
import useFileQuestionManager from "../../hooks/useFileQuestionManager";
import useQuestionStyles from "./questionStyles";
import QuestionAttachmentList from "../attachments/QuestionAttachmentList";
import { useDispatch } from "react-redux";
import { ALERT_TYPES, showAlert } from "../../../../redux/alert/alertActions";
import { fileMessages } from "../../../admin/attachments/messages";
import { acceptExtension } from "../../../common/attachments/attachmentsHelper";

export const FileUploadQuestion = ({ question, isDisabled, followUpUUID }) => {
    const classes = useQuestionStyles();
    const getTranslatedValue = useTranslatedValue();
    const fileInputRef = useRef();
    const dispatch = useDispatch();
    const maxNumberOfFiles = question.props?.fileLimit ?? 10;
    const fileSizeLimit = question.props?.fileSize?.max ?? 240000000;
    const { handleFileChange, handleFileUpdate, handleRemoveFile } = useFileQuestionManager(question, followUpUUID, maxNumberOfFiles, fileSizeLimit);

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
        }
    };
    const handleMultiFileChange = (e) => {
        const picked = Array.from(e.target.files || []);
        if (picked.length >= remainingSlots) {
            dispatch(showAlert(Date.now(), fileMessages.fileSizeLimit, ALERT_TYPES.error, { size: maxNumberOfFiles }));
        }

        const allowed = picked.slice(0, remainingSlots);

        allowed.forEach((file) => {
            const dt = new DataTransfer();
            dt.items.add(file);
            const singleEvent = {
                ...e,
                target: { ...e.target, files: dt.files },
            };
            handleFileChange(singleEvent);
        });

        e.target.value = "";
    };

    const files = Array.isArray(question.value) ? question.value : [];
    const remainingSlots = Math.max(0, maxNumberOfFiles - files.length);
    const canAddMore = remainingSlots > 0;
    const acceptedExtensions = acceptExtension(question?.props?.fileExtensions);

    const acceptValue = acceptedExtensions ? `${acceptedExtensions},` : "image/png";

    return (
        <>
            <Typography variant="body1" className={classes.questionText}>
                {question.mandatory && <span className={classes.mandatory}>*</span>}
                {getTranslatedValue(question.questionText)}
            </Typography>
            {getTranslatedValue(question.tooltip) && (
                <Typography variant="caption" className={classes.tooltip}>
                    {getTranslatedValue(question.tooltip)}
                </Typography>
            )}
            <Grid container alignItems="center" spacing={1} style={{ marginTop: 8 }}>
                <Grid item>
                    <Button
                        style={{ opacity: isDisabled || question.isDisabled || !canAddMore ? 0.5 : 1 }}
                        secondary
                        onClick={handleUploadClick}
                        disabled={isDisabled || question.isDisabled || !canAddMore}>
                        {getTranslatedValue(question.props?.uploadButtonText, "Upload File")}
                    </Button>
                </Grid>
                <input
                    ref={fileInputRef}
                    accept={acceptValue}
                    style={{ display: "none" }}
                    id={`sketch-upload-${question.id}`}
                    type="file"
                    onChange={handleMultiFileChange}
                    disabled={isDisabled || question.isDisabled || !canAddMore}
                    multiple
                />
                {files.map((file) => (
                    <QuestionAttachmentList key={file.id} file={file} onChange={handleFileUpdate} removeNewRow={handleRemoveFile} />
                ))}
            </Grid>
        </>
    );
};

export default FileUploadQuestion;
